
import withProps from 'recompose/withProps';
import compose from 'recompose/compose';
import {autocompleteProps} from "@xem/look/utils/autocompleteConfig";
import {withFormik} from "formik";

export default compose(
	withProps({ sx: {
			'.field-list':{ padding: 0, 'li':{
					listStyle: 'none',
					marginBottom: '8px',
					'.MuiFormControl-root':{
						margin: 0,
						minHeight: '40px'
					}
				}}
		}
	}),
	withFormik({
		enableReinitialize: true,
		displayName: 'FormRender', // helps with React DevTools
		mapPropsToValues: function ({ values }: any){
			return { directions: values?.directions || [] }
		},
		validate: function (values, { id, onChange }){
			func(onChange)(id, values?.directions);
		},
		handleSubmit: function (){}
	}),
	autocompleteProps,
	withProps((props: any)=>{
		let { values, id, setFieldValue } = props || {};
		let items = values[id] || [];
		items = items || [];
		function onSortEnd({ items }) {
			setFieldValue(id, items);
		}

		function onAdd({ insert }, index: number){
			return function onAdd(){
				insert(index + 1, {});
			}
		}

		function onRemove({ remove }, index: number){
			return function onRemove(){
				remove(index)
			}
		}

		let datasource = items.map((item: any, index: number)=>{
			return ({ weight: index, data: { index, name: `${id}.${index}`, item } })
		});

		return { datasource, items, values, onSortEnd, onAdd, onRemove }
	})
)